import { create, test, enforce } from 'vest';
import isEmail from 'validator/es/lib/isEmail';

enforce.extend({ isEmail });

const validate = create((formData) => {
    test('email', 'Must not be empty', () => {
        enforce(formData.email).isNotEmpty();
    });

    test('email', 'Must be a valid email address', () => {
        enforce(formData.email).isEmail();
    });

    test('password', 'Must not be empty', () => {
        enforce(formData.password).isNotEmpty();
    });
});

export default validate;
